export { View as VseBudetHorosho } from './view'
